import { apiSlice } from "../../../api/ApiService";
import { AppDispatch } from "../../../store/store";
import { getHeadersFromRedux } from "../../../utility/functions/common-functions";

const getEducationLibraryApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getEducationLibraryApi: builder.query({
      query: ({
        patientProfileId,
        lang,
      }: {
        patientProfileId: number;
        lang: string;
      }) => {
        const headers = getHeadersFromRedux();
        headers["X-Language"] = lang;
        return {
          url: `/api/v1/Patient/${patientProfileId}/educational-content`,
          method: "GET",
          headers,
        };
      },
      // Associate this query with a tag
      providesTags: (result, error, { patientProfileId, lang }) => [
        { type: "EducationLibrary", id: `${patientProfileId}-${lang}` },
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useGetEducationLibraryApiQuery } = getEducationLibraryApi;

export const invalidateEducationLibrary = (
  dispatch: AppDispatch,
  patientProfileId: number,
  lang: string
) => {
  dispatch(
    apiSlice.util.invalidateTags([
      { type: "EducationLibrary", id: `${patientProfileId}-${lang}` },
      { type: "MilestoneProgressBar", id: "LIST" },
    ])
  );
};

export default getEducationLibraryApi;
